import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
  Autocomplete,
  Switch,
} from "@mui/material";
import { Stack } from "@mui/system";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { useEffect, useState } from "react";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { useDispatch, useSelector } from "react-redux";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface TrafficSourceProps {
  open: boolean;
  handleClose: () => void;
  trafficSourceName: any;
  SetTrafficSourceName: any;
  selectedRowData: any;
  setSelectedRowData: any;
  selectedShareuid: any;
  setSelectedSharedUid: any;
  setMetaTrafficSource: any;
  trafficSourceData: any;
  setTrafficSourceData: any;
}

function EditTrafficSourceModal({
  open,
  handleClose,
  trafficSourceName,
  SetTrafficSourceName,
  selectedRowData,
  selectedShareuid,
  trafficSourceData,
}: TrafficSourceProps) {
  const token = useSelector(setUserToken);
  const oauthTokenHeader = token?.payload?.user?.userToken;

  // const [, setMetaTrafficSources] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [trafficSourceType, setTrafficSourceType] = useState(null);
  const [countAsClickInOut, setCountAsClickInOut] = useState(true);

  const UpdateNewTrafficSource = async () => {
    const data = {
      traffic_source_name: trafficSourceName,
      traffic_type: trafficSourceType,
      count_as_click_in_out: countAsClickInOut,
    };
    try {
      setLoading(true);
      setIsLoading(true);
      if (oauthTokenHeader) {
        await MetaEntitiesEndPointLogic.updateMetaTrafficSource(
          oauthTokenHeader,
          data,
          selectedShareuid
        );
      } else {
        throw new Error("User doesn't have permissions to create new themes");
      }
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaTrafficSourceDuplicate(
          oauthTokenHeader,
          dispatch
        );
      }
    } catch (error) {
      console.error(error, "error");
    } finally {
      setLoading(false);
      setIsLoading(false);
      handleClose();
      await MetaEntitiesEndPointLogic.getMetaTrafficSourceDuplicate(
        oauthTokenHeader,
        dispatch
      );
    }
  };

  useEffect(() => {
    if (oauthTokenHeader) {
      SetTrafficSourceName(trafficSourceData?.traffic_source_name);
      setCountAsClickInOut(trafficSourceData?.count_as_click_in_out);
      setTrafficSourceType(trafficSourceData?.traffic_type);
    }
    // eslint-disable-next-line
  }, [selectedRowData, SetTrafficSourceName, oauthTokenHeader,trafficSourceData]);

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
        >
          <Paper sx={{ padding: "16px 24px 20px 24px" }}>
            <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
              Edit New Traffic Source
            </DialogTitle>
            <Typography sx={{ mb: 1 }}>Details</Typography>
              <Grid container mt={0} columnSpacing={3}>
                <Grid item xs={6}>
                  <TextField
                    value={trafficSourceName}
                    id="outlined-multiline-flexible"
                    label="Traffic Source Name *" // Set your label here
                    placeholder="Enter unique Traffic Source Name" // Set your placeholder here
                    color="secondary"
                    size="small"
                    onChange={(e: any) => SetTrafficSourceName(e.target.value)}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={["Paid", "Organic", "Other"]}
                    sx={{ width: 400 }}
                    renderInput={(params) => <TextField {...params} label="Traffic Source Type" color="secondary" />}
                    size="small"
                    onChange={(_, value: any) => setTrafficSourceType(value)}
                    value={trafficSourceType}
                  />
                </Grid>

                <Grid item xs={12} mt={2}>
                  Include Clicks In Reports<Switch color="secondary" onChange={(e) => setCountAsClickInOut(e.target.checked)} checked={countAsClickInOut} />
                </Grid>
              </Grid>
            <Typography
              sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
            >
              This is a mandatory field.
            </Typography>

            <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
              <Button color="secondary" sx={{ mr: 1 }} onClick={handleClose}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="secondary"
                disabled={!trafficSourceName}
                onClick={UpdateNewTrafficSource}
                data-tracker="235"
              >
                Save Changes <SaveOutlinedIcon sx={{ ml: 1 }} />
              </Button>
            </Stack>
          </Paper>
        </Dialog>
      )}
    </>
  );
}

export default EditTrafficSourceModal;
